import { ArrowRight, Loader2, PhoneCall, AlertCircle, Building2, Users, X } from "lucide-react";

// Fenêtre de confirmation avant validation de la réservation :
// rassurer + responsabiliser (une formule = une vraie auto-école, appeler vite).
export default function ConfirmReservationModal({ understood, setUnderstood, saving, error, onConfirm, onClose }) {
  return (
    <div className="fixed inset-0 z-[90] flex items-end justify-center bg-black/50 p-0 sm:items-center sm:p-4" data-testid="confirm-modal" onClick={() => !saving && onClose()}>
      <div role="dialog" aria-modal="true" aria-labelledby="confirm-title" onClick={(e) => e.stopPropagation()}
        className="max-h-[92vh] w-full max-w-lg overflow-y-auto rounded-t-3xl bg-white p-6 shadow-2xl sm:rounded-3xl">
        <div className="flex items-start justify-between gap-3">
          <div>
            <p className="text-xs font-bold uppercase tracking-wider text-brand">Presque fini 🎉</p>
            <h2 id="confirm-title" className="mt-1 text-xl font-black tracking-tight text-neutral-900">Avant de valider, 2 choses à savoir</h2>
          </div>
          <button type="button" aria-label="Fermer" disabled={saving} onClick={onClose} className="rounded-full p-1 text-neutral-400 hover:bg-neutral-100 hover:text-neutral-700"><X className="h-5 w-5" /></button>
        </div>

        <ol className="mt-5 space-y-4">
          <li className="flex gap-3" data-testid="confirm-point-1">
            <span className="grid h-10 w-10 shrink-0 place-items-center rounded-2xl bg-brand/10 text-brand"><Building2 className="h-5 w-5" /></span>
            <span className="text-sm leading-relaxed text-neutral-700">
              <strong className="block text-neutral-900">{"Derrière ta formule, il y a une vraie auto-école"}</strong>
              {"Les places affichées dans ta ville viennent de plusieurs auto-écoles. Celle de ta formule n'a peut-être qu'"}<strong>une seule place</strong>{" à offrir ce mois-ci."}
            </span>
          </li>
          <li className="flex gap-3" data-testid="confirm-point-2">
            <span className="grid h-10 w-10 shrink-0 place-items-center rounded-2xl bg-brand/10 text-brand"><PhoneCall className="h-5 w-5" /></span>
            <span className="text-sm leading-relaxed text-neutral-700">
              <strong className="block text-neutral-900">{"Appelle-la le plus vite possible"}</strong>
              {"Dès que tu valides, tu reçois ses coordonnées. Appelle-la rapidement (sous 2 jours) pour fixer ton rendez-vous. Un rendez-vous manqué, c'est une place perdue pour un autre élève et pour l'auto-école."}
            </span>
          </li>
        </ol>

        <p className="mt-4 flex items-start gap-2 rounded-xl bg-neutral-50 px-4 py-3 text-xs leading-relaxed text-neutral-600" data-testid="confirm-limit">
          <Users className="mt-0.5 h-4 w-4 shrink-0 text-neutral-400" />
          {"Pour que chacun ait sa chance : 2 réservations maximum par personne sur 3 mois."}
        </p>

        <label className="mt-5 flex cursor-pointer items-start gap-3 rounded-xl border border-neutral-200 p-3 text-sm text-neutral-700 hover:border-brand/40">
          <input type="checkbox" checked={understood} onChange={(e) => setUnderstood(e.target.checked)} data-testid="r-understood"
            className="mt-0.5 h-5 w-5 shrink-0 rounded border-neutral-300 text-brand focus:ring-brand" />
          <span><strong>{"J'ai compris"}</strong>{" et je m'engage à appeler l'auto-école rapidement."}</span>
        </label>

        {error && (
          <p className="mt-3 flex items-start gap-2 rounded-xl bg-red-50 px-4 py-3 text-sm text-red-700" data-testid="confirm-error">
            <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" /> {error}
          </p>
        )}

        <button type="button" onClick={onConfirm} disabled={!understood || saving} data-testid="r-confirm-submit"
          className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-brand px-6 py-4 text-base font-bold text-white shadow-lg shadow-brand/20 hover:bg-brand-hover disabled:cursor-not-allowed disabled:opacity-50">
          {saving ? <><Loader2 className="h-5 w-5 animate-spin" /> Envoi en cours…</> : <>{"Je valide et je reçois les coordonnées"} <ArrowRight className="h-5 w-5" /></>}
        </button>
        <button type="button" onClick={onClose} disabled={saving} data-testid="r-confirm-cancel"
          className="mt-2 w-full rounded-xl px-6 py-3 text-sm font-semibold text-neutral-500 hover:text-neutral-800">
          Revenir au formulaire
        </button>
      </div>
    </div>
  );
}
